export default __webpack_public_path__ + "static/media/sprite.78c8ab41.svg";